module.exports = __webpack_public_path__ + "static/media/vtex25.d9b969b8.png";